var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorBannerIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-secondary, currentColor)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M30 24.333V29m0 4.667h.012M41.667 29c0 6.443-5.224 11.667-11.667 11.667S18.333 35.443 18.333 29 23.557 17.333 30 17.333 41.667 22.557 41.667 29"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorBannerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/errorBannerIcon.d3c4a19024580339d777d8509d1d5364.svg";